import { RefreshCw } from "lucide-react";
import type { AuditQuery } from "../../shared/audit-schemas";
import { Button } from "../components/ui/button";
import { AuditExport } from "./AuditExport";
export function AuditHeader({
  query,
  audience,
  organizationId,
  embedded,
  refresh,
  fetching,
}: {
  query: AuditQuery;
  audience: "customer" | "operations";
  organizationId: string | undefined;
  embedded: boolean | undefined;
  refresh: () => void;
  fetching: boolean;
}) {
  const Heading = embedded ? "h2" : "h1";
  return (
    <header className="flex flex-wrap items-start justify-between gap-4 border-b pb-5">
      <div>
        <Heading id="audit-title" className="m-0 text-2xl font-bold tracking-tight">
          Audit trail
        </Heading>
        <p className="mt-2 mb-0 max-w-2xl text-sm text-muted-foreground">
          Who did what, when it happened, and how it turned out.
        </p>
      </div>
      <div className="flex flex-wrap gap-2">
        <AuditExport
          key={`${audience}:${organizationId ?? "all"}:${JSON.stringify(query)}`}
          query={query}
          audience={audience}
          organizationId={organizationId}
        />
        <Button variant="outline" onClick={refresh} disabled={fetching}>
          <RefreshCw />
          Refresh
        </Button>
      </div>
    </header>
  );
}
